import { render, staticRenderFns } from "./ObjectModules.vue?vue&type=template&id=98a91c48&scoped=true&"
import script from "./ObjectModules.vue?vue&type=script&lang=js&"
export * from "./ObjectModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a91c48",
  null
  
)

export default component.exports